export const validatePhoneNumber = (phone) => {
    const phoneRegexExp = /^\+[0-9]?()[0-9](\s|\S)(\d[0-9]{8,16})$/;
    return phoneRegexExp.test(phone);
};

export const validateEmailId = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};